export const createCoupon = {
	url: `/coupons`,
	method: "POST",
};

export const updateCoupon = (couponId: string) => ({
	url: `/coupons/${couponId}`,
	method: "PATCH",
});

export const deleteCoupon = (couponId: string) => ({
	url: `/coupons/${couponId}`,
	method: "DELETE",
});

export const getCoupons = (query: string) => ({
	url: `/coupons?${query}`,
	method: "GET",
});

// Admin-wide: every coupon across the platform (not just the caller's own).
// /coupons (getMyCoupons) is createdById-scoped, so the admin needs this.
export const getAllCoupons = (query: string) => ({
	url: `/coupons/admin/all?${query}`,
	method: "GET",
});

export const updateCouponStatus = (couponId: string) => ({
	url: `/coupons/${couponId}/update-status`,
	method: "PATCH",
});
